// extracted by mini-css-extract-plugin
export default {"mainContainer":"RequestHistoryTable_mainContainer__ADGNq"};